import { useDataSubmit } from 'Simple/Data'

export function useOnClick(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'edit_email',
  })
  return async function onClick() {
    submit({ type: 'form_submit' })
  }
}
